import { createComponent } from '@mtfe/sweet';
import { oadLX } from '@mtfe/pr-oad';
import { ErrorPage } from '@mtfe/sweet-components';
import { container } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
import { ERROR_TEXT } from '../../constants';
import indexWmCrazyReady from './ready';

import { openSearchFeature } from '../../utils';
import { hideSkeleton } from '../../utils/dom';

import CrazyWaimaiModule from '../../modules/CrazyWaimaiModule/script';
import ShangouModules, { isShowShangouModules } from '../../modules/ShangouModules/script';
import Tab from '../../modules/Tab/script';
import { initIsShow, handleData, initStore } from '../utils';

import { experimentBanner, experimentGuideSearch } from '../../experiment';
import store from '../../store/index';

const { isInWeixin } = container;

const { storeCommon } = store;

const IndexWmCrazy = async () => {
    try {
        const { structInfo, tabsInfo } = storeCommon;

        // 解构结构信息，强依赖于后端。
        const {
            dom_sg_cps_unbind_coupon: domSgLargeRedBag,
            dom_sg_cps_unbind_coupon_poi: domSgLargeRedBagPoi,
            dom_sg_cps_unbind_coupon_sku: domSgSkuCoupon,
            dom_wm_big_coupon_none: domNoneCrazyCoupon,
        } = structInfo.struct;

        // 数据缓存初始化
        initStore(tabsInfo, [domSgLargeRedBagPoi, domSgSkuCoupon, domNoneCrazyCoupon, domSgLargeRedBag]);
        // 请求首页数据
        await handleData();

        // 判断哪些模块需要展示
        initIsShow(structInfo.struct);

        const events = {};

        const isShowShangou = isShowShangouModules();

        const data = {
            isShowShangou,
            activityEntranceIcon: '',
            isOnlyShowWaimai: !isShowShangou,
            tab: isShowShangou
                ? Tab({
                      waimaiModule: CrazyWaimaiModule(),
                      shangouModule: ShangouModules(),
                  })
                : '',
            waimaiModule: isShowShangou ? '' : CrazyWaimaiModule(),
        };

        // Banner试验
        await experimentBanner(data, events);
        // 高达入口展示使用
        // experimentGundamActivity(data);
        // 引导站内搜索，与高达入口展示使用实验冲突
        experimentGuideSearch(data);
        // 开启搜索功能
        openSearchFeature();

        // 样式适配
        if (isInWeixin) {
            style.headerContainer = style['headerContainer-wx'];
        } else {
            style.headerContainer = style['headerContainer-default'];
        }
        indexWmCrazyReady(isShowShangou);

        const component = createComponent(tpl, { data, style }, events);

        return component;
    } catch (error) {
        console.error(error);
        return ErrorPage({ text: ERROR_TEXT, oadLX });
    } finally {
        hideSkeleton();
    }
};

export default IndexWmCrazy;
